/* global dc */

const $ = require('jquery');

const manageButtonTemplate = '<a class="btn manage-dc">Manage Dynamic Content</a>';

module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            scheduleKey: '@',
            layoutId: '@',
        },
        link(scope, element) {
            const centerScroll = $('#center-panel > .hideScroll-wrapper');

            function manageDynamicContent() {
                if (scope.scheduleKey !== undefined) {
                    $('.manage-dc').remove();
                    dc.initialize(element, scope.scheduleKey, scope.layoutId);
                    // If the dc is at the bottom, sometimes we need to scroll to it
                    // in order to be able to edit.
                    centerScroll.scrollTop(element.position().top);
                }
            }

            element.append($(manageButtonTemplate));

            element.find('.manage-dc').one('click', manageDynamicContent);
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/manage-dc.directive.js